import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { InvoiceTopicItem } from 'src/admin-entity/interface/setting/invoice-topic-item.zod';
import * as api from 'src/api/setting/setting';
import { AppState } from 'src/store';

export const getInvoiceFieldList = createAsyncThunk(
    `settingSlice/getInvoiceFieldList`,
    async (_, { rejectWithValue }) => {
        try {
            const res = await api.getInvoiceFieldList();
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const registerInvoiceTemplate = createAsyncThunk(
    `settingSlice/registerInvoiceTemplate`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const { template, appliedTopicItemList } = (getState() as AppState).setting.invoiceTemplate;
            const temp = { ...template };
            temp.fields = [...appliedTopicItemList];
            const res = await api.registerInvoiceTemplate(temp);
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const getInvoiceTemplateList = createAsyncThunk(
    `settingSlice/getInvoiceTemplateList`,
    async ({ page, take, title }: { page: number; take: number; title?: string }, { getState, rejectWithValue }) => {
        try {
            // const { page, take, title } = (getState() as AppState).setting.invoiceTemplate.searchCondition;
            const res = await api.getInvoiceTemplateList(page, take, title);
            console.log(res.data);
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const deleteInvoiceTemplate = createAsyncThunk(
    `settingSlice/deleteInvoiceTemplate`,
    async (id: number, { getState, rejectWithValue }) => {
        try {
            const res = await api.deleteInvoiceTemplate(id);

            if (res.data) {
                const { page, take, title } = (getState() as AppState).setting.invoiceTemplate.searchCondition;
                const list = (await api.getInvoiceTemplateList(page, take, title)).data;

                return list;
            }

            // return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const getInvoiceTemplateDetail = createAsyncThunk(
    `settingSlice/getInvoiceTemplateDetail`,
    async (id: number, { rejectWithValue }) => {
        try {
            const res = await api.getInvoiceTemplateDetail(id);
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const updateInvoiceTemplate = createAsyncThunk(
    `settingSlice/updateInvoiceTemplate`,
    async (id: number, { getState, rejectWithValue }) => {
        try {
            const { template, appliedTopicItemList } = (getState() as AppState).setting.invoiceTemplate;
            const res = await api.updateInvoiceTemplate(id, {
                title: template.title,
                fields: appliedTopicItemList,
            });
            return res.data;
        } catch (err) {
            return rejectWithValue(err);
        }
    },
);

export const settingSlice = createSlice({
    name: 'settingSlice',
    initialState,
    reducers: {
        init: _ => {
            return {
                ...initialState,
            };
        },
        addTopicItemList: state => {
            state.invoiceTemplate.appliedTopicItemList.push(...state.invoiceTemplate.selectedTopicItemList);
            state.invoiceTemplate.selectedTopicItemList = [];
        },
        addEmptyTopic: state => {
            const count = state.invoiceTemplate.appliedTopicItemList.filter(i => i.key.includes('empty')).length;

            state.invoiceTemplate.appliedTopicItemList.push({
                isFixed: false,
                key: `empty_${count}`,
                text: `${count + 1}_(공백)`,
                priority: state.invoiceTemplate.appliedTopicItemList.length,
            });
        },
        selectTopicItemList: (state, action: PayloadAction<InvoiceTopicItem>) => {
            if (state.invoiceTemplate.selectedTopicItemList.findIndex(st => st.text === action.payload.text) >= 0) {
                state.invoiceTemplate.selectedTopicItemList = state.invoiceTemplate.selectedTopicItemList.filter(
                    st => st.text !== action.payload.text,
                );
            } else {
                state.invoiceTemplate.selectedTopicItemList.push(action.payload);
            }
        },
        selectAppliedTopicItemList: (state, action: PayloadAction<InvoiceTopicItem>) => {
            if (
                state.invoiceTemplate.selectedAppliedTopicItemList.findIndex(st => st.text === action.payload.text) >= 0
            ) {
                state.invoiceTemplate.selectedAppliedTopicItemList =
                    state.invoiceTemplate.selectedAppliedTopicItemList.filter(st => st.text !== action.payload.text);
            } else {
                state.invoiceTemplate.selectedAppliedTopicItemList.push(action.payload);
            }
        },
        removeAppliedTopicItemList: state => {
            state.invoiceTemplate.appliedTopicItemList = state.invoiceTemplate.appliedTopicItemList.filter(
                at =>
                    !state.invoiceTemplate.selectedAppliedTopicItemList.some(
                        sat => sat.text === at.text && !at.isFixed,
                    ),
            );
            state.invoiceTemplate.selectedAppliedTopicItemList = [];
        },
        moveToFront: state => {
            const sortedArr = state.invoiceTemplate.selectedAppliedTopicItemList.sort((a, b) => {
                const indexA = state.invoiceTemplate.appliedTopicItemList.findIndex(v => v.key === a.key);
                const indexB = state.invoiceTemplate.appliedTopicItemList.findIndex(v => v.key === b.key);

                return indexA - indexB;
            });

            sortedArr.reverse().forEach(value => {
                const index = state.invoiceTemplate.appliedTopicItemList.findIndex(at => at.key === value.key);
                const item = state.invoiceTemplate.appliedTopicItemList.splice(index, 1)[0];
                state.invoiceTemplate.appliedTopicItemList.unshift(item);
            });
        },
        moveToForward: state => {
            const indexs = [];
            state.invoiceTemplate.selectedAppliedTopicItemList.forEach(item => {
                const index = state.invoiceTemplate.appliedTopicItemList.findIndex(at => at.key === item.key);
                indexs.push(index);
            });

            if (indexs.includes(0)) {
                return;
            }

            indexs.forEach(index => {
                const temp = state.invoiceTemplate.appliedTopicItemList[index];
                state.invoiceTemplate.appliedTopicItemList[index] =
                    state.invoiceTemplate.appliedTopicItemList[index - 1];
                state.invoiceTemplate.appliedTopicItemList[index - 1] = temp;
            });
        },
        moveToBackward: state => {
            const indexs = [];
            state.invoiceTemplate.selectedAppliedTopicItemList.forEach(item => {
                const index = state.invoiceTemplate.appliedTopicItemList.findIndex(at => at.key === item.key);
                indexs.push(index);
            });

            if (indexs.includes(state.invoiceTemplate.appliedTopicItemList.length - 1)) {
                return;
            }

            indexs.forEach(index => {
                const temp = state.invoiceTemplate.appliedTopicItemList[index];
                state.invoiceTemplate.appliedTopicItemList[index] =
                    state.invoiceTemplate.appliedTopicItemList[index + 1];
                state.invoiceTemplate.appliedTopicItemList[index + 1] = temp;
            });
        },
        moveToEnd: state => {
            const sortedArr = state.invoiceTemplate.selectedAppliedTopicItemList.sort((a, b) => {
                const indexA = state.invoiceTemplate.appliedTopicItemList.findIndex(v => v.key === a.key);
                const indexB = state.invoiceTemplate.appliedTopicItemList.findIndex(v => v.key === b.key);

                return indexA - indexB;
            });

            sortedArr.forEach(value => {
                const index = state.invoiceTemplate.appliedTopicItemList.findIndex(at => at.key === value.key);
                const item = state.invoiceTemplate.appliedTopicItemList.splice(index, 1)[0];
                state.invoiceTemplate.appliedTopicItemList.push(item);
            });
        },
        applyAllInvoiceTopic: state => {
            const filterd = state.invoiceTemplate.topicItemList.filter(
                t => !state.invoiceTemplate.appliedTopicItemList.find(at => at.key === t.key) && !t.isFixed,
            );
            state.invoiceTemplate.appliedTopicItemList.push(...filterd);
        },
        reset: state => {
            state.invoiceTemplate.appliedTopicItemList = state.invoiceTemplate.appliedTopicItemList
                .filter(at => at.isFixed)
                .sort((a, b) => a.priority - b.priority);
            state.invoiceTemplate.selectedAppliedTopicItemList = [];
            state.invoiceTemplate.selectedTopicItemList = [];
        },
        detailReset: state => {
            state.invoiceTemplate.appliedTopicItemList = state.invoiceTemplate.template.fields;
        },
        updateTemplateTitle: (state, action: PayloadAction<string>) => {
            state.invoiceTemplate.template.title = action.payload;
        },
        updateSearchConditionPage: (state, action: PayloadAction<number>) => {
            state.invoiceTemplate.searchCondition.page = action.payload;
        },
        updateSearchConditionTake: (state, action: PayloadAction<number>) => {
            state.invoiceTemplate.searchCondition.take = action.payload;
        },
        updateSearchConditionTitle: (state, action: PayloadAction<string>) => {
            state.invoiceTemplate.searchCondition.title = action.payload;
        },
        searchConditionReset: state => {
            state.invoiceTemplate.searchCondition = initialState.invoiceTemplate.searchCondition;
        },
    },
    extraReducers: builder => {
        builder.addCase(getInvoiceFieldList.fulfilled, (state, action) => {
            state.invoiceTemplate.topicItemList = action.payload;
        });
        builder.addCase(getInvoiceTemplateList.fulfilled, (state, action) => {
            state.invoiceTemplate.templateList = action.payload;
        });
        builder.addCase(deleteInvoiceTemplate.fulfilled, (state, action) => {
            state.invoiceTemplate.templateList = action.payload;
        });
        builder.addCase(getInvoiceTemplateDetail.fulfilled, (state, action) => {
            state.invoiceTemplate.template = action.payload;
            state.invoiceTemplate.appliedTopicItemList = action.payload.fields;
        });
        builder.addCase(updateInvoiceTemplate.fulfilled, (state, action) => {
            state.invoiceTemplate.appliedTopicItemList = action.payload.fields;
            state.invoiceTemplate.template = action.payload;
        });
    },
});

export const {
    init,
    addTopicItemList,
    addEmptyTopic,
    selectTopicItemList,
    selectAppliedTopicItemList,
    removeAppliedTopicItemList,
    moveToFront,
    moveToForward,
    moveToBackward,
    moveToEnd,
    applyAllInvoiceTopic,
    reset,
    detailReset,
    updateTemplateTitle,
    updateSearchConditionPage,
    updateSearchConditionTake,
    updateSearchConditionTitle,
    searchConditionReset,
} = settingSlice.actions;
export default settingSlice.reducer;
